import { localPrefs } from "../native-modules/tare/getLocalPrefs";

/**
 * Stamps a device-scoped NPS trigger pref with the current time so a later
 * Homepage/SERP visit can show the survey. Best-effort: a failed write never
 * blocks the originating screen.
 */
export async function recordNpsTrigger(namespace: string, key: string): Promise<void> {
  try {
    await localPrefs.setLong(namespace, key, Date.now());
  } catch {
    return;
  }
}
